import { WSTable } from "@wingspanhq/fe-component-library";
import React, { useMemo } from "react";

import { ComparisonRowData, ComparisonTableProps } from "./types";
import { buildComparisonColumns } from "./utils/buildComparisonColumns";
import { buildComparisonTableData } from "./utils/buildComparisonTableData";

export const ComparisonTable: React.FC<ComparisonTableProps> = props => {
  const tableData = useMemo(() => buildComparisonTableData(props), [props]);
  const columns = useMemo(
    () => buildComparisonColumns(props.currentVersion),
    [props.currentVersion]
  );

  return (
    <WSTable<ComparisonRowData>
      columns={columns}
      showVerticalDivider
      tableData={tableData}
    />
  );
};
